import pricingCustom from '@assets/images/pricingCustom.png';
import pricingPlanBasic from '@assets/images/pricingPlanBasic.png';
import pricingPlanPremium from '@assets/images/pricingPlanPremium.png';
import pricingPlanPro from '@assets/images/pricingPlanPro.png';
import pricingPlanStandard from '@assets/images/pricingPlanStandard.png';

export type planTypes = 'basic' | 'standard' | 'pro' | 'premium' | 'custom';

export const PlanInfos = [
  { name: 'Basic Starter', icon: pricingPlanBasic },
  { name: 'Standard', icon: pricingPlanStandard },
  { name: 'Pro', icon: pricingPlanPro },
  { name: 'Premium', icon: pricingPlanPremium },
  { name: 'Custom', icon: pricingCustom },
];

export const Features = [
  {
    name: 'User Profile',
    hasDescription: true,
    plans: ['basic', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Points Systems',
    hasDescription: false,
    plans: ['basic', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'News',
    hasDescription: false,
    plans: ['basic', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Appreciation',
    hasDescription: false,
    plans: ['basic', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Articles, Quiz',
    hasDescription: true,
    plans: ['basic', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Employee Survey',
    hasDescription: true,
    plans: ['basic', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Event RSVP',
    hasDescription: false,
    plans: ['basic', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Rewards Redemption',
    hasDescription: false,
    plans: ['', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Event Check-in System',
    hasDescription: false,
    plans: ['', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Leader Wallet',
    hasDescription: true,
    plans: ['', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'TV Channel',
    hasDescription: true,
    plans: ['', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Jetso Catalogue',
    hasDescription: true,
    plans: ['', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Networking',
    hasDescription: true,
    plans: ['', 'standard', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Workshop',
    hasDescription: true,
    plans: ['', '', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Employee Recognition Award - Nomination & Election',
    hasDescription: true,
    plans: ['', '', 'pro', 'premium', 'custom'],
  },
  {
    name: 'Web Version + Team Integration',
    hasDescription: true,
    plans: ['', '', '', 'premium', 'custom'],
  },
  {
    name: 'ERA - Grand Election',
    hasDescription: false,
    plans: ['', '', '', 'premium', 'custom'],
  },
  {
    name: 'ESG Initiatives, Go Green Secondhand Goods Exchange',
    hasDescription: false,
    plans: ['', '', '', 'premium', 'custom'],
  },
  {
    name: 'CSR Hub (Volunteer Service) ',
    hasDescription: true,
    plans: ['', '', '', 'premium', 'custom'],
  },
];

export const Comparisons = [
  {
    section: 'App Features',
    details: '',
  },
  // {
  //   section: 'Backend management system',
  //   details:
  //     'You’ll pay face value for any rewards that employees redeem in our catalog. For example, a $25 Visa gift card will cost you $25. This cost is billed separate from your subscription. You’ll never pay for points or allowances that go unused.',
  // },
  // {
  //   section: 'Add-ons',
  //   details:
  //     'You’ll pay face value for any rewards that employees redeem in our catalog. For example, a $25 Visa gift card will cost you $25. This cost is billed separate from your subscription. You’ll never pay for points or allowances that go unused.',
  // },
];

export default Comparisons;
